import styled, { css } from 'styled-components';

interface ScToggleSwitchProps {
  horizontal: boolean;
}

export const ScToggleSwitch = styled.div<ScToggleSwitchProps>`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  position: relative;
  width: 40px;
  background: ${({ theme }) => theme.grayLightColor};
  border-radius: 24px;

  .toggle-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 40px;
    position: relative;
    cursor: pointer;

    &:after {
      content: '';
      position: absolute;
      top: 0;
      left: 50%;
      width: 40px;
      height: 100%;
      border-radius: 50%;
      z-index: 1;
      background-color: transparent;
      transition:
        transform 0.7s cubic-bezier(0.17, 0.67, 0.44, 0.89),
        background-color 0.3ms cubic-bezier(0.17, 0.67, 0.14, 1.03);
      transform: translate(-50%, 2px);
    }

    .label {
      font-weight: 700;
      font-size: 10px;
      line-height: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      letter-spacing: -0.01em;
      text-transform: uppercase;
      color: ${({ theme }) => theme.grayColor};
      width: 100%;
      height: 100%;

      svg {
        path {
          fill: ${({ theme }) => theme.grayColor};
        }
        rect {
          stroke: ${({ theme }) => theme.grayColor};
        }
      }
    }

    &:not(.toggle-btn__active):hover {
      .label {
        color: ${({ theme }) => theme.whiteColor};

        svg {
          path {
            fill: ${({ theme }) => theme.whiteColor};
          }
          rect {
            stroke: ${({ theme }) => theme.whiteColor};
          }
        }
      }
    }

    &__active {
      &:after {
        background-color: ${({ theme }) => theme.whiteColor};
        transform: translate(-50%, 0);
      }

      .label {
        color: ${({ theme }) => theme.blackColor};
        position: absolute;
        z-index: 2;

        svg {
          path {
            fill: ${({ theme }) => theme.blackColor};
          }
          rect {
            stroke: ${({ theme }) => theme.blackColor};
          }
        }
      }
    }
  }

  ${({ horizontal }) =>
    horizontal &&
    css`
      flex-direction: row;
      height: 32px;
      width: 100%;
      transform: translate(0, 0);

      .toggle-btn {
        height: 100%;

        &:after {
          width: 100%;
          height: 100%;
          border-radius: 24px;
          transition: background-color 0.3ms linear;
        }

        .label {
          font-size: 16px;
          line-height: 24px;
        }

        &__active {
          &:after {
            height: 40px;
            transform: translate(-50%, -10%);
          }

          .label {
            color: ${({ theme }) => theme.blackColor};
            position: absolute;
            z-index: 2;

            svg {
              path {
                fill: ${({ theme }) => theme.blackColor};
              }
              rect {
                stroke: ${({ theme }) => theme.blackColor};
              }
            }
          }
        }
      }
    `}
`;
